export class ReportJob {
	job: string;
	status: string;
	fetch: string;
}



// WEBPACK FOOTER //
// ./src/app/models/report-job.model.ts